import React, { useCallback } from 'react';
import noop from 'lodash/noop';
import { createField } from '../helpers';
import { SelectValue, SelectProps } from '../types';
import Tags from 'react-tag-autocomplete';
import '../../styles/react-tags.scss';

type TagsProps = SelectProps & {
    placeholder?: string;
    autofocus?: boolean;
    autoresize?: boolean;
};

/**
 * Displays a field that lets you enter a list of tags
 */
const TagsField = createField<SelectValue[], undefined, TagsProps>(({
    name,
    options = [],
    value = [],
    onValueChange = noop,
    autofocus = false,
    placeholder = 'Add new tags',
    autoresize = false,
}) => {
    const handleAddition = useCallback((tag) => {
        onValueChange([...value, tag.id], value, name, null);
    }, [onValueChange]);

    const handleDelete = useCallback((i) => {
        onValueChange(value.filter((_, j) => i !== j), value, name, null);
    }, [onValueChange]);

    return <Tags
        autofocus={autofocus}
        placeholderText={placeholder}
        autoresize={autoresize}
        tags={options
            .filter((o) => value.includes(o.value))
            .map((o) => ({ id: o.value, name: o.label }))
        }
        suggestions={options.map((o) => ({ id: o.value, name: o.label }))}
        onAddition={handleAddition}
        onDelete={handleDelete}

        // @ts-expect-error
        handleAddition={handleAddition}
        handleDelete={handleDelete}
    />;
});

export default TagsField;
